/* Oud Al Abraj — storefront behaviour (no dependencies) */
(function () {
  'use strict';

  var AB = window.AB || {};
  var routes = AB.routes || {};
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var fmt = AB.moneyFormat || '₹{{amount}}';
    function withDec(n, dec, thou, decSep) {
      var parts = (n / 100).toFixed(dec).split('.');
      var whole = parts[0];
      if (thou === ',' && /₹|Rs|INR/.test(fmt)) {
        var last3 = whole.slice(-3), rest = whole.slice(0, -3);
        whole = rest ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3 : last3;
      } else {
        whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      }
      return parts[1] ? whole + decSep + parts[1] : whole;
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDec(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDec(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDec(cents, 0, '.', ','); break;
      default: value = withDec(cents, 2, ',', '.');
    }
    value = value.replace(/[.,]00$/, '');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- drawers (menu, search, filters, cart) ---------- */
  var openDrawerEl = null;
  var lastTrigger = null;
  function focusables(el) {
    return Array.prototype.filter.call(el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])'), function (n) { return n.offsetParent !== null; });
  }
  function openDrawer(id, trigger) {
    var d = document.getElementById(id);
    if (!d) return;
    if (openDrawerEl && openDrawerEl !== d) closeDrawer(true);
    lastTrigger = trigger || document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.querySelectorAll('[data-ab-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    openDrawerEl = d;
    var panel = d.querySelector('.ab-drawer__panel');
    var auto = d.querySelector('[data-ab-autofocus]');
    setTimeout(function () { (auto || panel).focus(); }, 60);
  }
  function closeDrawer(silent) {
    var d = openDrawerEl;
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.querySelectorAll('[data-ab-open="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openDrawerEl = null;
    if (!silent && lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (!openDrawerEl) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') {
      var f = focusables(openDrawerEl.querySelector('.ab-drawer__panel'));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- cart ---------- */
  function cartEl() { return document.querySelector('[data-ab-cart]'); }
  function cartSectionId() {
    var c = cartEl();
    var s = c && c.closest('.shopify-section');
    return s ? s.id.replace('shopify-section-', '') : '';
  }
  function cartEnabled() { var c = cartEl(); return c && c.getAttribute('data-enabled') !== 'false'; }
  function setCount(n) {
    document.querySelectorAll('[data-ab-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
  }
  function renderCart(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('AbCartInner');
    var cur = document.getElementById('AbCartInner');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    var src = document.querySelector('[data-ab-count-src]');
    if (src) setCount(src.getAttribute('data-ab-count-src'));
  }
  function refreshCart() {
    var id = cartSectionId();
    if (!id) return Promise.resolve();
    return fetch((routes.root || '/') + '?sections=' + id, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderCart(data[id]); })
      .catch(function () {});
  }
  function postJSON(url, body) {
    var id = cartSectionId();
    if (id) { body.sections = id; body.sections_url = window.location.pathname; }
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
        return data;
      });
    });
  }
  function useSections(data) {
    var id = cartSectionId();
    if (data && data.sections && id && data.sections[id]) { renderCart(data.sections[id]); return Promise.resolve(data); }
    return refreshCart().then(function () { return data; });
  }
  function addItems(items) {
    return postJSON((routes.cartAdd || '/cart/add') + '.js', { items: items }).then(useSections);
  }
  function afterAdd() {
    if (cartEnabled()) openDrawer('AbCart');
    else window.location.href = routes.cart || '/cart';
  }
  function changeLine(key, qty) {
    var panel = document.querySelector('#AbCart .ab-drawer__panel');
    if (panel) panel.style.opacity = '.6';
    return postJSON((routes.cartChange || '/cart/change') + '.js', { id: key, quantity: qty })
      .then(useSections)
      .catch(function (e) { window.alert(e.message); })
      .then(function () { if (panel) panel.style.opacity = ''; });
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-ab-open-cart]')) && cartEnabled()) { e.preventDefault(); openDrawer('AbCart', t); return; }
    if ((t = e.target.closest('[data-ab-open]'))) { e.preventDefault(); openDrawer(t.getAttribute('data-ab-open'), t); return; }
    if (e.target.closest('[data-ab-close]')) { e.preventDefault(); closeDrawer(); return; }
    if ((t = e.target.closest('[data-ab-line]'))) { e.preventDefault(); changeLine(t.getAttribute('data-ab-line'), parseInt(t.getAttribute('data-qty'), 10) || 0); return; }
    if ((t = e.target.closest('[data-ab-add],[data-oaa-quick-add]'))) {
      e.preventDefault();
      var id = t.getAttribute('data-ab-add') || t.getAttribute('data-oaa-quick-add');
      if (!id || t.getAttribute('aria-busy') === 'true') return;
      var label = t.innerHTML;
      t.setAttribute('aria-busy', 'true');
      addItems([{ id: Number(id), quantity: 1 }])
        .then(function () {
          if (t.isConnected) { t.classList.add('is-added'); t.textContent = 'Added ✓'; setTimeout(function () { t.classList.remove('is-added'); t.innerHTML = label; }, 1600); }
          afterAdd();
        })
        .catch(function (err) { window.alert(err.message); })
        .then(function () { t.removeAttribute('aria-busy'); });
      return;
    }
    if ((t = e.target.closest('[data-ab-tab]'))) { selectTab(t); return; }
    if ((t = e.target.closest('[data-ab-prev],[data-ab-next]')) && !t.closest('[data-ab-slider]')) {
      var wrap = t.closest('.ab-wrap');
      var track = wrap && (wrap.querySelector('[data-ab-rail-wrap]:not([hidden]) [data-ab-track]'));
      if (track) track.scrollBy({ left: (t.hasAttribute('data-ab-next') ? 1 : -1) * track.clientWidth * 0.9, behavior: reduced ? 'auto' : 'smooth' });
      return;
    }
    if ((t = e.target.closest('[data-ab-pin-check]'))) {
      var box = t.closest('[data-ab-pin]');
      var input = box.querySelector('input');
      var msg = box.querySelector('[data-ab-pin-msg]');
      var v = (input.value || '').replace(/\D/g, '');
      msg.textContent = /^[1-9]\d{5}$/.test(v) ? (msg.getAttribute('data-ok') || '').replace('[pin]', v) : 'Please enter a valid 6-digit pincode.';
    }
  });

  /* ---------- change events: sort, filters ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-ab-sort]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', t.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
      return;
    }
    var form = t.closest('form[data-ab-filters]');
    if (form && /-side$/.test(form.id) && t.type === 'checkbox') form.submit();
  });

  /* ---------- tabs ---------- */
  function selectTab(tab) {
    var list = tab.closest('[role="tablist"]');
    if (!list) return;
    list.querySelectorAll('[data-ab-tab]').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
  }
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ab-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[data-ab-tab]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = tabs[(i + tabs.length) % tabs.length];
    next.focus(); selectTab(next);
  });

  /* ---------- sliders (hero, product gallery) ---------- */
  function initSlider(root) {
    if (root.__ab) return;
    root.__ab = true;
    var track = root.querySelector('[data-ab-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dotsBox = root.querySelector('[data-ab-dots]');
    var counter = root.querySelector('[data-ab-counter]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ab-goto]'));
    var dots = [];
    var index = 0;
    if (dotsBox && slides.length > 1) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to ' + (i + 1) + ' of ' + slides.length);
        if (i === 0) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function () { stop(); go(i); });
        dotsBox.appendChild(b);
        dots.push(b);
      });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    }
    function mark(i) {
      if (i === index) return;
      index = i;
      dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      thumbs.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = track.clientWidth || 1;
        mark(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w))));
      });
    }, { passive: true });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { go(Number(b.getAttribute('data-ab-goto'))); }); });
    var prev = root.querySelector('[data-ab-prev]');
    var next = root.querySelector('[data-ab-next]');
    if (prev) prev.addEventListener('click', function () { stop(); go(index - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(index + 1); });
    var timer = null;
    var secs = Number(root.getAttribute('data-autoplay')) || 0;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (secs > 0 && slides.length > 1 && !reduced) {
      timer = setInterval(function () { if (!document.hidden) go(index + 1); }, secs * 1000);
      ['pointerdown', 'focusin', 'wheel', 'touchstart'].forEach(function (ev) { root.addEventListener(ev, stop, { passive: true }); });
    }
    root.__abGo = go;
  }

  /* ---------- announcement ---------- */
  function initAnn(root) {
    if (root.__ab) return;
    root.__ab = true;
    var msgs = root.querySelectorAll('.ab-ann__msg');
    if (msgs.length < 2 || reduced) return;
    var i = 0;
    setInterval(function () {
      if (window.innerWidth >= 990 || document.hidden) return;
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 3800);
  }

  /* ---------- product form ---------- */
  function initProduct(root) {
    if (root.__ab) return;
    root.__ab = true;
    var form = document.getElementById(root.getAttribute('data-form'));
    if (!form) return;
    var idInput = form.querySelector('[data-ab-variant-id]');
    var priceEl = root.querySelector('[data-ab-price]');
    var noteEl = root.querySelector('[data-ab-note]');
    var noteBase = noteEl ? noteEl.textContent.replace(/^Set of \d+ · /, '') : '';
    var saveEl = root.querySelector('[data-ab-save]');
    var saveAmt = root.querySelector('[data-ab-save-amt]');
    var savePct = root.querySelector('[data-ab-save-pct]');
    var wasEl = root.querySelector('[data-ab-was]');
    var cmpEls = root.querySelectorAll('[data-ab-cmp]');
    var stickyPrice = document.querySelector('[data-ab-sticky-price]');
    var picksBox = form.querySelector('[data-ab-picks]');
    var pickTitle = form.querySelector('[data-ab-pick-title]');
    var setLine = form.querySelector('[data-ab-setline]');
    var qtyWrap = form.querySelector('[data-ab-qty-wrap]');
    var qtyInput = form.querySelector('[data-ab-qty]');
    var atc = form.querySelector('[data-ab-atc]');
    var buyNow = form.querySelector('[data-ab-buy-now]');
    var errEl = form.querySelector('[data-ab-error]');
    var mainTitle = root.getAttribute('data-main-title') || '';
    var pairPct = Number(root.getAttribute('data-pair-pct')) || 0;
    var trioPct = Number(root.getAttribute('data-trio-pct')) || 0;
    var order = [];

    function size() { var r = form.querySelector('input[name="ab_bundle"]:checked'); return r ? Number(r.value) : 1; }
    function picks() { return Array.prototype.slice.call(form.querySelectorAll('[data-ab-pick]')); }
    function variantPrice() { return Number(idInput.getAttribute('data-price')) || 0; }
    function qty() { var q = parseInt(qtyInput && qtyInput.value, 10); return q > 0 ? Math.min(q, 20) : 1; }

    picks().forEach(function (p) { if (p.getAttribute('aria-pressed') === 'true') order.push(p); });

    function normalisePicks() {
      var need = size() - 1;
      var on = order.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; });
      while (on.length > need) { on.shift().setAttribute('aria-pressed', 'false'); }
      if (on.length < need) {
        picks().forEach(function (p) {
          if (on.length < need && p.getAttribute('aria-pressed') !== 'true') { p.setAttribute('aria-pressed', 'true'); on.push(p); }
        });
      }
      order = on;
    }

    function update() {
      var s = size();
      var sum = variantPrice() * (s > 1 ? 1 : qty());
      if (s > 1) order.forEach(function (p) { sum += Number(p.getAttribute('data-price')) || 0; });
      var pct = s === 3 ? trioPct : s === 2 ? pairPct : 0;
      var save = Math.floor(sum * pct / 100);
      var total = sum - save;
      if (priceEl) priceEl.textContent = formatMoney(total);
      if (stickyPrice) stickyPrice.textContent = formatMoney(total);
      if (noteEl) noteEl.textContent = (s > 1 ? 'Set of ' + s + ' · ' : '') + noteBase;
      if (saveEl) { saveEl.hidden = !(save > 0); if (saveAmt) saveAmt.textContent = formatMoney(save); if (savePct) savePct.textContent = pct; }
      if (wasEl) { wasEl.hidden = !(save > 0); wasEl.textContent = formatMoney(sum); }
      cmpEls.forEach(function (c) { c.hidden = s > 1; });
      if (qtyWrap) qtyWrap.hidden = s > 1;
      if (picksBox) {
        picksBox.hidden = s === 1;
        if (pickTitle) pickTitle.textContent = s === 3 ? pickTitle.getAttribute('data-t3') : pickTitle.getAttribute('data-t2');
        if (setLine) {
          var names = order.map(function (p) { return p.getAttribute('data-name'); });
          setLine.textContent = s > 1 ? 'In your set: ' + [mainTitle].concat(names).join(' + ') : '';
        }
      }
    }

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'ab_bundle') { normalisePicks(); update(); }
      if (t.hasAttribute('data-ab-qty')) update();
      if (t.hasAttribute('data-ab-variant')) {
        idInput.value = t.value;
        idInput.setAttribute('data-price', t.getAttribute('data-price'));
        form.querySelectorAll('[data-ab-variant]').forEach(function (r) { r.closest('.ab-chip').classList.toggle('is-active', r.checked); });
        var ok = t.getAttribute('data-available') === 'true';
        if (atc) atc.disabled = !ok;
        if (buyNow) buyNow.disabled = !ok;
        try { var u = new URL(window.location.href); u.searchParams.set('variant', t.value); window.history.replaceState({}, '', u.toString()); } catch (err) {}
        update();
      }
    });
    form.addEventListener('input', function (e) { if (e.target.hasAttribute('data-ab-qty')) update(); });

    form.addEventListener('click', function (e) {
      var step = e.target.closest('[data-ab-qty-step]');
      if (step && qtyInput) {
        e.preventDefault();
        qtyInput.value = Math.max(1, Math.min(20, qty() + Number(step.getAttribute('data-ab-qty-step'))));
        update();
        return;
      }
      var p = e.target.closest('[data-ab-pick]');
      if (!p) return;
      e.preventDefault();
      if (p.getAttribute('aria-pressed') === 'true') return;
      p.setAttribute('aria-pressed', 'true');
      order.push(p);
      normalisePicks();
      update();
    });

    function collectItems() {
      var s = size();
      var items = [{ id: Number(idInput.value), quantity: s > 1 ? 1 : qty() }];
      if (s > 1) {
        order.forEach(function (p) {
          var vid = p.getAttribute('data-variant-id');
          if (!vid) throw new Error('Please choose your other oils.');
          items.push({ id: Number(vid), quantity: 1 });
        });
      }
      var merged = {}, out = [];
      items.forEach(function (it) {
        if (merged[it.id]) merged[it.id].quantity += it.quantity;
        else { merged[it.id] = { id: it.id, quantity: it.quantity }; out.push(merged[it.id]); }
      });
      return out;
    }

    function submit(goCheckout) {
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      var items;
      try { items = collectItems(); } catch (err) { if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } return; }
      var btn = goCheckout ? buyNow : atc;
      if (btn) btn.setAttribute('aria-busy', 'true');
      addItems(items)
        .then(function () { if (goCheckout) window.location.href = '/checkout'; else afterAdd(); })
        .catch(function (err) { if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } })
        .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(false); });
    if (buyNow) buyNow.addEventListener('click', function (e) { e.preventDefault(); submit(true); });

    normalisePicks();
    update();

    /* phone: the bar appears only after the main Add to cart button has scrolled up out of view */
    var sticky = document.querySelector('[data-ab-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var on = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', on);
          sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          var b = sticky.querySelector('button');
          if (b) b.tabIndex = on ? 0 : -1;
        });
      }, { rootMargin: '-60px 0px 0px 0px' }).observe(atc);
    }
  }

  /* ---------- init ---------- */
  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-ab-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-ab-ann]').forEach(initAnn);
    scope.querySelectorAll('[data-ab-product]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ab-tab]');
    if (tab) selectTab(tab);
    var slide = e.target.closest && e.target.closest('.ab-slide');
    var slider = slide && slide.closest('[data-ab-slider]');
    if (slider && slider.__abGo) slider.__abGo(Array.prototype.indexOf.call(slide.parentNode.children, slide));
  });
})();
